import script from "./morphedButton.vue?vue&type=script&setup=true&lang=js"
export * from "./morphedButton.vue?vue&type=script&setup=true&lang=js"

import "./morphedButton.vue?vue&type=style&index=0&id=97195e52&lang=css"
import "./morphedButton.vue?vue&type=style&index=1&id=97195e52&lang=css"

const __exports__ = script;

export default __exports__